<div id="about-div">
  <app-jz-tab-group [tabComponentList]="tabComponentList"></app-jz-tab-group>
</div>
